<template>
    <div>
        <div>
    <b-card class="card-news-form" header-tag="header" footer-tag="footer">
      <!-- for loading page -->
      <app-loading :className="isLoading ? 'loading' : ''"></app-loading>

        <div slot="header">
          <i class="fa fa-list-ul" aria-hidden="true"></i>
            Reward Form
          <div class="card-header-actions">
            <a href="https://bootstrap-vue.js.org/docs/components/progress" class="card-header-action" rel="noreferrer noopener" target="_blank">
              <small class="text-muted">docs</small>
            </a>
          </div>
        </div>
        <div>

          <b-row>
            <b-col sm="12">
              <alert-success :redirectName="'reward-home'" :show="successMessage != ''"> {{ successMessage }} </alert-success>
              <b-alert class="text-center" :show="errorMessage != ''" variant="danger"> {{ errorMessage }} </b-alert>

              <!-- Thumbnail -->
              <b-form-group>
                <div class="text-center">
                  <img class="thumbnail" :src="previewThumbnail" alt="Thumbnail">
                </div>
                <b-input-group>
                <div class="custom-file">
                    <input type="file" class="custom-file-input" @change="changeThumbnailFile">
                    <label class="custom-file-label"> {{ thumbnail.name || 'choose thumbnail file' }} </label>
                </div>
                <b-button variant="outline-secondary" @click="previewThumbnail = '/images/101/thumbnail.png'; thumbnail = {}">
                  Set Default
                </b-button>
                </b-input-group>
              </b-form-group>

              <!-- Type -->
              <b-form-group>
              <label>Type</label>
              <v-select :class="classSelect(fieldErrors.type)"
                 v-model="form.type"
                 :options="['price', 'price2']"
                 :placeholder="'please select zone of privilege'">
              </v-select>
              </b-form-group>

               <!-- Name -->
              <b-form-group>
                <label>Name</label>
                <b-input-group prepend="TH">
                    <b-input :state="feedback(fieldErrors.nameTH)" v-model="form.nameTH" placeholder="กรุณาใส่ชื่อภาษาไทย"></b-input>
                </b-input-group>
                <b-input-group prepend="EN">
                    <b-input :state="feedback(fieldErrors.nameEN)" v-model="form.nameEN" placeholder="please enter english name."></b-input>
                </b-input-group>
              </b-form-group>

              <!-- Details -->
              <b-form-group>
                <label>Details</label>
                <b-input-group prepend="TH">
                    <b-input v-model="form.detailTH" placeholder="กรุณาใส่รายละเอียดภาษาไทย"></b-input>
                </b-input-group>
                <b-input-group prepend="EN">
                    <b-input v-model="form.detailEN" placeholder="please enter english detail."></b-input>
                </b-input-group>
              </b-form-group>

              <!-- Redeem Need -->
              <b-form-group>
                <label>Redeem Need</label>
                <b-input-group>
                    <b-input v-model="form.redeemNeed" placeholder="please enter needed redeem"></b-input>
                </b-input-group>
              </b-form-group>

              <!-- Start - end showing-->
              <b-form-group>
                <label>Start - End Showing reward period</label>
                <b-input-group>
                    <date-time-picker v-model="form.startShowing" :config="datePickerOptions"></date-time-picker>
                    <div class="fix-font"> To </div>
                    <date-time-picker v-model="form.endShowing" :config="datePickerOptions"></date-time-picker>
                </b-input-group>
              </b-form-group>

              <!-- Start - end available-->
              <b-form-group>
                <label>Start - End available reward period</label>
                <b-input-group>
                    <date-time-picker v-model="form.startAvailable" :config="datePickerOptions"></date-time-picker>
                    <div class="fix-font"> To </div>
                    <date-time-picker v-model="form.endAvailable" :config="datePickerOptions"></date-time-picker>
                </b-input-group>
              </b-form-group>

              <!-- stock total -->
              <b-form-group>
                <label>Stock total</label>
                <b-input-group>
                    <b-input type="number" v-model="form.stockTotal" placeholder="please enter stock total"></b-input>
                </b-input-group>
              </b-form-group>

              <!-- conditions -->
                <b-form-group>
                <label>Conditions</label>
                <transition-group name="list" tag="div">
                <b-input-group v-for="(condition, index) in form.conditions" :key="condition.id">
                    <b-input-group-prepend is-text> Limit </b-input-group-prepend>
                    <b-form-input :disabled="noEdit(condition)" v-model="condition.limitAmount"></b-form-input>
                    <b-input-group-append is-text>
                        Time
                    </b-input-group-append>
                    <b-input-group-prepend is-text> Per </b-input-group-prepend>
                    <b-form-input :disabled="noEdit(condition)" v-model="condition.limitPer"></b-form-input>
                    <v-select class="select-condition" :disabled="noEdit(condition)" v-model="condition.limitUnit" :options="['day', 'month', 'end']"></v-select>
                    <b-input-group-append>
                        <b-button @click="removeCondition(index)" variant="ghost-danger">
                        <i class="fa fa-minus" aria-hidden="true"></i>
                        Remove
                        </b-button>
                    </b-input-group-append>
                </b-input-group>
                </transition-group>

                <b-input-group>
                    <b-button @click="addCondition" class="mr-2 mt-2" size="sm" variant="primary">
                        <i class="fa fa-plus" aria-hidden="true"></i>
                        Add Condition
                    </b-button>
                </b-input-group>
              </b-form-group>

              <!-- Gallery -->
              <b-form-group>
                <b-button variant="ghost-primary" size="sm" @click="showGallery = !showGallery">
                    Galleries {{ showGallery ? 'hide' : 'show'}}
                    <i class="fa fa-folder-open-o" aria-hidden="true"></i>
                </b-button>
                <font class="hint">* Show as sliding banner at the top of application.</font>
                 <app-gallery
                  :show="showGallery"
                  :gallery="form.gallery"
                  :removeGallery="form.removeGallery">
                </app-gallery>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <div slot="footer">
          <b-button @click="$router.go(-1)" class="mr-2" size="sm" variant="secondary">
            <i class="fa fa-angle-left" aria-hidden="true"></i>
            Back
          </b-button>
          <b-button :disabled="!isActive" @click="save" class="mr-2" type="submit" size="sm" variant="primary">
            <i class="fa fa-dot-circle-o"></i>
            Save
          </b-button>
          <b-button :disabled="!isActive" v-b-modal.confirmDelete v-if="$route.params.id" type="reset" size="sm" variant="danger">
            <i class="fa fa-ban"></i>
            Delete
          </b-button>
          <alert-confirm
            :id="'confirmDelete'"
            @confirm="deleteReward">
            confirm to delete ?
          </alert-confirm>
        </div>
    </b-card>
    </div>
    </div>
</template>

<script>
import AlertSuccess from '../../components/alert/AlertSuccess';
import AlertConfirm from '../../components/alert/AlertConfirm';
import Loading from '../../components/Loading';
import vSelect from 'vue-select';
import uniqid from 'uniqid';
import DatePicker from 'vue-bootstrap-datetimepicker';
import Gallery from '../../components/Gallery';
import { stringFullToDate } from '../../assets/utils/time';

export default {
  data () {
    return {
      successMessage: '',
      errorMessage: '',
      previewThumbnail: '/images/101/thumbnail.png',
      thumbnail: {},
      isLoading: false,
      isActive: true,
      fieldErrors: {},
      datePickerOptions: {
        format: 'DD/MM/YYYY HH:mm:ss',
        useCurrent: false,
        showClear: true,
        showClose: true,
        locale: 'th'
      },
      showGallery: false,
      form: {
        type: '',
        nameTH: '',
        nameEN: '',
        detailTH: '',
        detailEN: '',
        redeemNeed: '',
        startShowing: null,
        endShowing: null,
        startAvailable: null,
        endAvailable: null,
        stockTotal: '',
        gallery: [],
        removeGallery: [],
        conditions: [],
        removeConditions: []
      }
    };
  },
  methods: {
    getData () {
      const id = this.$route.params.id;
      if (id) {
        this.isLoading = true;
        this.axios.get(process.env.VUE_APP_URL_UNIVERSAL_API + '/mqdc/rewards/' + id)
          .then(response => {
            const data = response.data.data;
            if (!data) {
              throw new Error('data not found');
            }
            this.previewThumbnail = data.thumbnail;
            this.form = {
              type: data.type,
              nameTH: data.nameTH,
              nameEN: data.nameEN,
              detailTH: data.detailTH,
              detailEN: data.detailEN,
              redeemNeed: data.redeemNeed,
              startShowing: data.showingPeriod.start ? new Date(data.showingPeriod.start.timestamp * 1000) : null,
              endShowing: data.showingPeriod.end ? new Date(data.showingPeriod.end.timestamp * 1000) : null,
              startAvailable: data.availablePeriod.start ? new Date(data.availablePeriod.start.timestamp * 1000) : null,
              endAvailable: data.availablePeriod.end ? new Date(data.availablePeriod.end.timestamp * 1000) : null,
              stockTotal: data.stockTotal,
              conditions: data.conditions.map(condition => {
                return {
                  id: condition.id,
                  limitAmount: condition.limitAmount,
                  limitPer: condition.limitPer,
                  limitUnit: condition.limitUnit
                };
              }),
              gallery: data.galleries.map(image => { return { id: image.id || uniqid('image-'), url: image.url }; }),
              removeGallery: [],
              removeConditions: []
            };
          })
          .catch(error => {
            this.handleError(error);
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        this.setDefault();
      }
    },
    changeThumbnailFile (e) {
      const files = e.target.files || e.dataTransfer.files;
      this.thumbnail = files[0];
      this.previewThumbnail = URL.createObjectURL(this.thumbnail);
    },
    handleError (error) {
      this.fieldErrors = {};
      this.errorMessage = error.message;
      if (error.response) {
        this.errorMessage = error.response.data.message;
        const data = error.response.data.data;
        this.setFieldErrors(data);
      }
      this.isLoading = false;
    },
    setFieldErrors (fields) {
      if (fields) {
        for (const field of fields) {
          this.fieldErrors[field.param] = { message: field.msg, isCorrect: false };
        }
      }
    },
    deleteReward () {
      this.isActive = false;
      this.isLoading = true;
      this.axios.delete(process.env.VUE_APP_URL_UNIVERSAL_API + '/mqdc/rewards/' + this.$route.params.id)
        .then(response => {
          this.successMessage = 'delete reward success';
        })
        .catch(error => {
          this.handleError(error);
        });
    },
    save () {
      // this.isActive = false;
      this.fieldErrors = {};
      this.isLoading = true;
      const id = this.$route.params.id;
      const bodyFormData = new FormData();
      bodyFormData.append('thumbnail', this.thumbnail);
      bodyFormData.append('type', this.form.type);
      bodyFormData.append('nameTH', this.form.nameTH);
      bodyFormData.append('nameEN', this.form.nameEN);
      bodyFormData.append('detailTH', this.form.detailTH);
      bodyFormData.append('detailEN', this.form.detailEN);
      bodyFormData.append('redeemNeed', this.form.redeemNeed);
      bodyFormData.append('startShowing', stringFullToDate(this.form.startShowing));
      bodyFormData.append('endShowing', stringFullToDate(this.form.endShowing));
      bodyFormData.append('startAvailable', stringFullToDate(this.form.startAvailable));
      bodyFormData.append('endAvailable', stringFullToDate(this.form.endAvailable));
      bodyFormData.append('stockTotal', this.form.stockTotal);
      // conditions
      bodyFormData.append('removeConditions', this.form.removeConditions.length > 0 ? this.form.removeConditions : null); // id
      for (const condition of this.form.conditions) { // array of object
        if (condition.id.split('condition-').length > 1) {
          bodyFormData.append('appendConditions', [condition.id, condition.limitAmount, condition.limitPer, condition.limitUnit]);
        }
      }
      // Gallery
      bodyFormData.append('removeGallery', this.form.removeGallery);
      for (const image of this.form.gallery) {
        bodyFormData.append('gallery', image.file || null);
      }

      if (id) { // update
        this.axios.patch(process.env.VUE_APP_URL_UNIVERSAL_API + '/mqdc/rewards/' + id, bodyFormData)
          .then(response => {
            this.successMessage = 'update reward finish';
          })
          .catch(error => {
            this.handleError(error);
          });
      } else { // create
        this.axios.post(process.env.VUE_APP_URL_UNIVERSAL_API + '/mqdc/rewards', bodyFormData)
          .then(response => {
            this.successMessage = 'create reward finish';
          })
          .catch(error => {
            this.handleError(error);
          });
      }
    },
    addCondition () {
      this.form.conditions.push({ id: uniqid('condition-'), limitAmount: '', limitPer: '', limitUnit: 'day' });
    },
    removeCondition (index) {
      if (this.form.conditions[index].id.split('condition-').length <= 1) {
        this.form.removeConditions.push(this.form.conditions[index].id);
      }
      this.form.conditions.splice(index, 1);
    },
    setDefault () {
      this.previewThumbnail = '/images/101/thumbnail.png';
      this.form = {
        type: '',
        nameTH: '',
        nameEN: '',
        detailTH: '',
        detailEN: '',
        redeemNeed: '',
        startShowing: null,
        endShowing: null,
        startAvailable: null,
        endAvailable: null,
        stockTotal: '',
        gallery: [],
        removeGallery: [],
        conditions: [],
        removeConditions: []
      };
    }
  },
  computed: {
    feedback () {
      return data => {
        if (!data) {
          return null;
        } else {
          return data.isCorrect;
        }
      };
    },
    classSelect () {
      return data => {
        if (!data) {
          return '';
        } else {
          return 'select-validate-fail';
        }
      };
    },
    noEdit () {
      return condition => {
        return condition.id.split('condition').length <= 1;
      };
    }
  },
  components: {
    AlertSuccess,
    AlertConfirm,
    'app-loading': Loading,
    'v-select': vSelect,
    'date-time-picker': DatePicker,
    'app-gallery': Gallery
  },
  mounted () {
    this.getData();
  },
  watch: {
    '$route' (to, from) {
      this.getData();
    }
  }
};
</script>

<style scoped>
    .list-item {
    display: inline-block;
    margin-right: 10px;
    }
    .list-enter-active, .list-leave-active {
    transition: all 0.5s;
    }
    .list-leave-to /* .list-leave-active below version 2.1.8 */ {
    opacity: 0;
    transform: translateX(30px);
    }
    .list-enter {
    opacity: 0;
    transform: translateY(30px);
    }
    .thumbnail{
      width: auto;
      max-height: 150px;
      -webkit-box-shadow: 0px 1px 4px 0px rgba(0,0,0,0.75);
      -moz-box-shadow: 0px 1px 4px 0px rgba(0,0,0,0.75);
      box-shadow: 0px 1px 4px 0px rgba(0,0,0,0.75);
      margin-bottom: 5px;
    }
    .fix-font{
        margin-top: 8px;
        margin-left: 10px;
        margin-right: 10px;
    }
    .select-condition {
        width: 120px;
    }
    .hint{
      font-size: 9px;
      color: #f86c6b;
    }
</style>

<style>
   .select-condition .vs__dropdown-toggle {
        padding: 0 0 7px;
    }
  .select-validate-fail .vs__search::placeholder,
  .select-validate-fail .vs__dropdown-toggle,
  .select-validate-fail .vs__dropdown-menu {
    border: 1px solid #f86c6b;
  }
</style>
